// extracted by mini-css-extract-plugin
export default {"layoutInnerWrapper":"EventManagerLayout_layoutInnerWrapper__XdACt"};